import React from 'react';
import { classes } from '../utils';
import styles from './input.module.scss';

interface ICustomInputProps {
  type: string;
  id: string;
  value: string | boolean;
  ModuleClassName: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
  placeholder?: string;
  error?: string;
  name?: string;
  maxCharLength?: number;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onFocus?: () => void;
}
const CustomInput: React.FC<ICustomInputProps> = ({
  type,
  id,
  value,
  onChange,
  label,
  placeholder,
  error,
  name,
  ModuleClassName,
  maxCharLength,
  onBlur,
  onFocus,
}) => {
  const divClass = classes(
    ModuleClassName ?? '',
    styles.field,
    error ? 'mfrmFormGroup formError' : 'mfrmFormGroup',
  );
  return (
    <div className={divClass} id={`${id}_container`}>
      <input
        type={type}
        aria-label={label}
        onChange={onChange}
        value={typeof value === 'boolean' ? value.toString() : value}
        name={name}
        id={id}
        placeholder={placeholder}
        aria-invalid={!!error}
        aria-required="true"
        maxLength={maxCharLength}
        onBlur={onBlur}
        onFocus={onFocus}
      />
      <label htmlFor={id}>{label}</label>

      <p id={`error_${id}`} role="alert" aria-live="assertive">
        {error}
      </p>
    </div>
  );
};

export default CustomInput;
